import { useState  } from '@wordpress/element';

import { Button, Flex, FlexBlock, FlexItem, CheckboxControl  } from '@wordpress/components';
import { Icon, arrowRight } from '@wordpress/icons';
import TextField from '@mui/material/TextField';
import { useSelector, useDispatch } from 'react-redux';
import {stepOne,stepThree} from '../actions';
import { __ } from '@wordpress/i18n';
import UpgradeButton from './UpgradeButton';

export default function buildWibsite(props){
    const license = useSelector((state)=>state.licenseActivate);

    const pageStep = useSelector((state)=>state.stepLoad);
    const dispatch = useDispatch();
    const [checkboxes, setCheckboxes] = useState({
        delete: true,
        themes: true,
        plugins: true,
        content:true,
      });

      const handleCheckboxChange = (checkboxName) => {
        setCheckboxes({
          ...checkboxes,
          [checkboxName]: !checkboxes[checkboxName],
        });
      };


return( <div className='aisb-site-build-wrap'>

            <div className='aisb-site-build'>
                <Flex className='header'>

                    <FlexItem>
                    <div class="aisb-back">
                    <div class="sb-column-close"><Button onClick={()=>dispatch(stepOne(true))} className="close">❮ Back</Button></div>
                </div>
                    </FlexItem>

                    <FlexItem>  
                        <div className="header-text">
                        <UpgradeButton/>       
                        </div>
                 </FlexItem>
                </Flex>
            </div>
            <div className='aisb-site-main'>
                <div className='aisb-site-form'>
                    <h2>   {__('Lets Build Your Website', 'vayu-blocks') }</h2>
                    <h4 className='aisb-site-sub-heading'>{__('Before be Continue Please Confirm These Options -', 'vayu-blocks') }</h4>
                    <div className='aisb-site-options'>
                    
                    {/* onChange={() => handleCheckboxChange('content')} */}
                        <div class="group"><input type="checkbox" id="delete" checked={checkboxes.delete} /> <label for="delete">Import Demo </label></div>
                        <div class="group"><input type="checkbox" id="themes" checked={checkboxes.themes} /> <label for="themes">Install & Activate Theme </label></div>
                        <div class="group"><input type="checkbox" id="plugins" checked={checkboxes.plugins} /> <label for="plugins">Install Required Plugins </label></div>
                        <div class="group"><input type="checkbox" id="content" checked={checkboxes.content} /> <label for="content">Install Demo content </label></div>

                
                    </div>

                    {/* <div>
                    <h4>About You</h4>
                    <div className='aisb-site-about'>
                    <Flex>
                    <FlexItem>
                    <TextField size="small" id="outlined-basic" label="Name" variant="outlined"  />
                    </FlexItem>
                    <FlexBlock>
                    <TextField size="small" id="outlined-basic" label="Email" variant="outlined"  />
                    </FlexBlock>
                    </Flex>
                    <div className='aisb-iagree'><CheckboxControl label="I agree to receive Newsletter & Updates" /> </div>
                    </div>
                    </div> */}


                    <div className='btn-center'><span className='aisb-install-btn' onClick={()=>dispatch(stepThree(true))}>Build My Website<b><Icon size ={22} icon={ arrowRight } /></b></span></div>
                </div>
            </div>

  </div>
  );
}